export const projectManagementTimelineArticle = {
  title: 'Project Management Hub: Timeline, Automations & Reports',
  slug: 'project-management-timeline',
  content: `Project Management Hub: Timeline, Automations & Reports

Track timelines and automate delivery updates.

1) Timeline tab
- Open /project-management#timeline to view the Gantt timeline.
- Click tasks or milestones to review details.

2) Automations
- Use Automations to trigger updates (team plan).

3) Reports
- Reports aggregates progress and risk insights.

4) URL hashes
- Tab changes update the URL hash for deep linking.
`,
};
